/**
 * Labstep
 */

export const placeholder = 'Select extension';
